import React, { useState, useEffect, FormEvent } from "react";
import Button from "../../../components/Form/Button";
import Loading from "../../../components/Loading";
import { SimpleResponse } from "../../../services/api/Request";
import { SetModal } from "../../../components/Modal";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "./periods.css";
import WeekPeriod, { IWeekPeriod } from "../../../services/api/WeekPeriod";

const Periods: React.FC = () => {
  const [loading, isLoading] = useState<Boolean>(true);
  const [response, setResponse] = useState<SimpleResponse>();
  const dateCalendarInit = new Date(2021,7,1);
  const dateCalendarEnd = new Date(2021,7,31);

  const [dateRangeW1, setDateRangeW1] = useState<Date[]|null[]>([null, null]);
  const [startDateW1, endDateW1] = dateRangeW1;
  const [dateRangeS, setDateRangeS] = useState<Date[]|null[]>([null, null]);
  const [startDateS, endDateS] = dateRangeS;

  async function handleFormSubmit(event: FormEvent) {
      event.preventDefault();

         let data: IWeekPeriod = {
          startDateW1: startDateW1!.getDate(),
          endDateW1: endDateW1!.getDate(),
        };

        let dataS: IWeekPeriod = {
          startDateW1: startDateS!.getDate(),
          endDateW1: endDateS!.getDate(),
        };
    
        const response: SimpleResponse = await WeekPeriod.UpdateActual(data);
        await WeekPeriod.UpdatePlan(dataS);
        setResponse(response);
   
  }

  useEffect(() => {
    isLoading(true);
    
    Promise.all([WeekPeriod.GetActual(), WeekPeriod.GetPlan()])
      .then((value) => {
        setDateRangeW1([new Date(2021,7,value[0].startDateW1), new Date(2021,7,value[0].endDateW1)]);

        setDateRangeS([new Date(2021,7,value[1].startDateW1), new Date(2021,7,value[1].endDateW1)]);

        isLoading(false);
      })
      .catch(() => undefined);
  }, []);

  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <React.Fragment>
            {response ? SetModal.FromResponse(response, () => {
                setResponse(undefined);
            }) : null}
            <section className="content__block">
            <form className="form" onSubmit={handleFormSubmit}>
            <div className="content__header">
              <h2 className="content__title">Periods</h2>

              <Button
                className="button button--blue button--icon button--save"
                title="Save"
              />
            </div>
              <div className="calendar-container">
                <DatePicker
                  inline
                  selectsRange={true}
                  startDate={startDateW1}
                  endDate={endDateW1}
                  minDate={dateCalendarInit}
                  maxDate={dateCalendarEnd}
                  onChange={(update:any) => { setDateRangeW1(update); }}
                  calendarClassName="hideWeekName"
                  renderCustomHeader={() => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      Actual
                    </div>
                  )}
                />
              </div>
              <div className="calendar-container" style={{marginTop:"20px"}}>
                <DatePicker
                  inline
                  selectsRange={true}
                  startDate={startDateS}
                  endDate={endDateS}
                  minDate={dateCalendarInit}
                  maxDate={dateCalendarEnd}
                  onChange={(update:any) => { setDateRangeS(update); }}
                  calendarClassName="hideWeekName"
                  renderCustomHeader={() => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                     Plan
                    </div>
                  )}
                />
              </div>
            
            </form>
          </section>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Periods;
